<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      // OpenGraph data (Most widely used)
      {
        property: "og:title",
        content: "Inner Me - self-compassionate app for your emotion",
      },
      { property: "og:site_name", content: "Inner Me" },
      { property: "og:type", content: "website" },
      {
        property: "og:image",
        content: "/timeline2.png",
      },
      // Often the same as your meta description, but not always.
      {
        property: "og:description",
        content:
          "Voice chat with InnerMe's AI platform to identify your stress level.",
      },

      // Twitter card
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:title",
        content: "Inner Me - self-compassionate app for your emotion",
      },
      {
        name: "twitter:description",
        content:
          "Voice chat with InnerMe's AI platform to identify your stress level.",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "@alligatorio" },
      {
        name: "twitter:image:src",
        content: "/timeline2.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "Inner Me - self-compassionate app for your emotion",
      },
      {
        itemprop: "description",
        content:
          "Voice chat with InnerMe's AI platform to identify your stress level.",
      },
      {
        itemprop: "image",
        content: "/timeline2.png",
      },
    ],
  },
  computed: {
    clickSfx() {
      return this.$store.getters["sfx/click"];
    },
  },
  watch: {
    clickSfx(val) {
      if (val) {
        this.playClick();
      }
    },
  },
  setup() {},
  mounted() {
    this.loadArticles();
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
